import { render, staticRenderFns } from "./ProductStockFilter.vue?vue&type=template&id=546330a4"
import script from "./ProductStockFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductStockFilter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports